import cookie from 'js-cookie'

import { fetchApi5 } from 'api/index'

export const fetchProfilesApi = (ids: number[]) =>
  fetchApi5('/users/get', {
    method: 'POST',
    body: JSON.stringify({
      ids,
      s_post: cookie.get('s_post'),
    }),
  })
